var exports = {
  "SM": "xaf9ae18d--c4fef5--desktop-banner",
  "Sl": "xaf9ae18d--c4fef5--image",
  "VN": "xaf9ae18d--c4fef5--close",
  "Qs": "xaf9ae18d--c4fef5--content",
  "pq": "xaf9ae18d--c4fef5--info",
  "wm": "xaf9ae18d--c4fef5--logo",
  "Cv": "xaf9ae18d--c4fef5--copyright",
};

module.exports = exports;
